// Electronixo click sound: a soft, tactile "tock" (a tiny filtered tap + a short warm pulse),
// generated live with no audio file. Plays on links, buttons and options.
// Mobile: the audio engine is unlocked on the first touch, and the sound plays on finger lift
// (before the page navigates), only for real taps, never while scrolling.
(() => {
  let ctx = null;
  let noise = null;
  let last = 0;
  const TARGETS = 'a, button, summary, label, [role="button"], [command], input[type="radio"], input[type="checkbox"], select';

  // Let Safari play page sounds even when the phone's silent switch is on (Safari 16.4+).
  try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}

  const ensure = () => {
    if (!ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      ctx = new AC();
      // short white-noise buffer reused for the tap
      noise = ctx.createBuffer(1, Math.floor(ctx.sampleRate * 0.03), ctx.sampleRate);
      const data = noise.getChannelData(0);
      for (let i = 0; i < data.length; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / data.length);
    }
    if (ctx.state !== 'running') ctx.resume();
    return ctx;
  };

  // iOS/Android unlock: play a silent sound inside the first touch.
  const unlock = () => {
    const c = ensure();
    if (!c) return;
    const b = c.createBufferSource();
    b.buffer = c.createBuffer(1, 1, 22050);
    b.connect(c.destination);
    b.start(0);
  };
  document.addEventListener('touchstart', unlock, { passive: true, once: true, capture: true });
  document.addEventListener('pointerdown', unlock, { passive: true, once: true, capture: true });

  const play = () => {
    const now = performance.now();
    if (now - last < 70) return;
    last = now;
    const c = ensure();
    if (!c) return;
    try {
      const t = c.currentTime + 0.005;
      const out = c.createGain();
      out.gain.value = 0.35;
      out.connect(c.destination);

      // 1) the tap: a 25 ms burst of filtered noise (crisp, like a key)
      const src = c.createBufferSource();
      src.buffer = noise;
      const bp = c.createBiquadFilter();
      bp.type = 'bandpass';
      bp.frequency.value = 2600;
      bp.Q.value = 1.4;
      const gN = c.createGain();
      gN.gain.setValueAtTime(0.5, t);
      gN.gain.exponentialRampToValueAtTime(0.0001, t + 0.025);
      src.connect(bp).connect(gN).connect(out);
      src.start(t);
      src.stop(t + 0.03);

      // 2) the body: a short warm pulse dropping in pitch (gives it a soft "tock")
      const osc = c.createOscillator();
      const gO = c.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(520, t);
      osc.frequency.exponentialRampToValueAtTime(240, t + 0.07);
      gO.gain.setValueAtTime(0.0001, t);
      gO.gain.exponentialRampToValueAtTime(0.6, t + 0.004);
      gO.gain.exponentialRampToValueAtTime(0.0001, t + 0.08);
      osc.connect(gO).connect(out);
      osc.start(t);
      osc.stop(t + 0.09);
    } catch (e) { /* stay silent */ }
  };

  const isTarget = (el) => {
    const hit = el instanceof Element ? el.closest(TARGETS) : null;
    return hit && !hit.matches(':disabled, [aria-disabled="true"]');
  };

  // Mouse: on press.
  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' && e.button === 0 && isTarget(e.target)) play();
  }, { passive: true, capture: true });

  // Touch: on finger lift, only if the finger did not travel (a tap, not a scroll).
  let sx = 0, sy = 0, moved = false;
  document.addEventListener('touchstart', (e) => {
    const t = e.touches[0];
    sx = t.clientX; sy = t.clientY; moved = false;
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', (e) => {
    const t = e.touches[0];
    if (Math.hypot(t.clientX - sx, t.clientY - sy) > 10) moved = true;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', (e) => {
    if (!moved && isTarget(e.target)) play();
  }, { passive: true, capture: true });

  // Keyboard.
  document.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && isTarget(e.target)) play();
  }, { passive: true });
})();
